// extracted by mini-css-extract-plugin
export default {"colorBox":"colorBox__OjQxhw","defaultColorText":"defaultColorText__Y2kvnZ","defaultColorWrapper":"defaultColorWrapper__Wbw0RX"};